export const iconFontAwesomeHumanitarianGopuram = (
	<i className="fa-solid fa-gopuram"></i>
);
